<app-auth-shell [testimonial]="false">
  @if (invitationMissing()) {
    <app-auth-header
      [title]="'pages.auth.joinOrganization.missing.title' | transloco"
      [subtitle]="'pages.auth.joinOrganization.missing.subtitle' | transloco" />
    <vx-button class="mt-8" size="lg" [fullWidth]="true" routerLink="/">
      {{ 'pages.auth.joinOrganization.openDashboard' | transloco }}
    </vx-button>
  } @else if (invitation() && user()) {
    <app-auth-header
      [title]="
        'pages.auth.joinOrganization.title'
          | transloco: { organizationName: invitation()!.organization.name }
      "
      [subtitle]="'pages.auth.joinOrganization.subtitle' | transloco" />

    <app-auth-panel>
      <div class="flex items-center gap-3">
        <vx-avatar
          size="lg"
          [src]="user()!.avatar"
          [initials]="userInitials()" />
        <div class="flex min-w-0 flex-col">
          <span class="text-13 tracking-tight text-zinc-500">
            {{ 'pages.auth.joinOrganization.signedInAs' | transloco }}
          </span>
          <span class="truncate text-sm tracking-tight text-zinc-100">
            {{ userName() || user()!.email }}
          </span>
          @if (userName()) {
            <span class="truncate text-13 tracking-tight text-zinc-400">
              {{ user()!.email }}
            </span>
          }
        </div>
      </div>

      @if (isAlreadyMember()) {
        <vx-callout tone="info">
          {{ 'pages.auth.joinOrganization.alreadyMember' | transloco }}
        </vx-callout>
        <vx-button size="lg" [fullWidth]="true" (click)="openOrganization()">
          {{ 'pages.auth.joinOrganization.openOrganization' | transloco }}
        </vx-button>
      } @else {
        @if (joinFailed()) {
          <vx-callout tone="danger">
            {{ 'pages.auth.joinOrganization.failed' | transloco }}
          </vx-callout>
        }
        <vx-button
          size="lg"
          [fullWidth]="true"
          [loading]="isJoining()"
          (click)="join()">
          {{ 'pages.auth.joinOrganization.join' | transloco }}
        </vx-button>
      }
    </app-auth-panel>

    <p class="mt-5 text-center text-13 tracking-tight text-zinc-400">
      {{ 'pages.auth.joinOrganization.notYou' | transloco }}
      <button
        type="button"
        class="text-zinc-200 underline underline-offset-2 hover:text-zinc-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-50"
        (click)="useOtherAccount()">
        {{ 'pages.auth.joinOrganization.useOtherAccount' | transloco }}
      </button>
    </p>
  } @else {
    <vx-skeleton class="h-6 w-6 rounded-md" />
    <vx-skeleton class="mt-5 h-6.5 w-56" />
    <vx-skeleton class="mt-2 h-4 w-72" />
    <vx-skeleton class="mt-8 h-36 w-full rounded-2xl" />
  }
</app-auth-shell>
